
export default {
  name: 'AppLoadingScreen',
  props: {
    isLoading: {
      type: Boolean,
      required: true
    }
  }
};
